import { styled } from '../../config'

export const TextInput = styled('input', {
  fontFamily: 'inherit',
  border: `1px solid $gray0500`,
  borderRadius: '6px',
  background: 'transparent',
  padding: `10px 12px`,
  fontSize: '$14',
  lineHeight: '$20',
  outline: 'none',
  color: '$gray1000',
  transition: 'all 100ms ease',
  marginBottom: '$4',
  '&::placeholder': {
    color: '$gray0600'
  },
  '&:focus': {
    boxShadow: `0px 0px 0px 4px $gray0300`
  },
  '&:disabled': {
    color: '$gray0800'
  },
  variants: {
    dark: {
      true: {
        '&::placeholder': {
          color: '$whiteA500'
        },
        backgroundColor: '$whiteA050',
        border: 'none',
        color: '$white',
        '&:disabled': {
          color: '$whiteA300'
        }
      }
    },
    ghost: {
      true: {
        borderColor: '#505050',
        backgroundColor: 'transparent',
        color: '$gray0200',
        '&:disabled': {
          color: '$gray0600'
        }
      }
    },
    outlineDark: {
      true: {
        color: '$gray0200',
        '&:disabled': {
          color: '$gray0500'
        }
      }
    },
    round: {
      true: { borderRadius: '$round' }
    },
    widthFull: {
      true: { width: '100%' }
    }
  }
})
